import { useEffect } from 'react'

const sources = {
  'facebook-embed': 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2',
  'tagboard-embed': 'https://static.tagboard.com/embed/assets/js/embed.js',
  'twitter-embed': 'https://platform.twitter.com/widgets.js'
}

const hasElement = ({ html, name }) => {
  return html.indexOf(name) !== -1
}

const useDynamicScripts = ({ html, scripts }: { html: string; scripts: string[] }) => {
  useEffect(() => {
    scripts.forEach(scriptName => {
      const elementExists = hasElement({ html, name: scriptName })

      //if element does not exist in the html or if the script has already been added to the DOM
      if (!elementExists || document.getElementById(scriptName)) return

      const script = document.createElement('script')
      script.id = scriptName
      script.async = true
      script.defer = true

      const cleanup = () => {
        const existingScript = document.getElementById(scriptName)
        if (existingScript) {
          document.body.removeChild(existingScript)
        }
      }

      script.src = sources[scriptName]

      document.body.appendChild(script)
      return cleanup
    })
  }, [html, scripts])
}

export default useDynamicScripts
